package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ExamImportResponse(
    @SerialName("exam_id") val examId: String? = null,
    @SerialName("processed_records") val processedRecords: Int? = null,
    val created: Int? = null,
    val updated: Int? = null,
    @SerialName("absent_subjects") val absentSubjects: Int? = null,
    @SerialName("validation_errors") val validationErrors: List<String>? = null
)
